/** Whether copy should use cycling duel language. */
export function notificationSportIsCycling(sport, cyclingFlag = false) {
    return cyclingFlag || sport === 'CYCLING';
}
/** What the player still needs to do ("your cards", "your 6 duels", …). */
export function openRoundActionPhrase(round, cycling) {
    if (cycling)
        return `your ${round.picksRequired} duels`;
    if (round.pickMode === 'FLEXIBLE')
        return 'your cards';
    return `your ${round.picksRequired} picks`;
}
/** Leading verb for an open-round nudge. */
export function openRoundVerb(round, cycling) {
    if (cycling)
        return 'Call';
    if (round.pickMode === 'FLEXIBLE')
        return 'Build';
    return 'Make';
}
/** When the slate locks — cycling stages vs football kickoff. */
export function openRoundDeadline(cycling) {
    return cycling ? 'the stage starts' : 'the first kickoff';
}
/** Title for the generic lock-soon reminder. */
export function lockSoonTitle(cycling) {
    return cycling ? 'Calls lock soon' : 'Cards lock soon';
}
/** Noun in mini-league reminder titles ("cards lock soon"). */
export function lockSoonNoun(cycling) {
    return cycling ? 'calls' : 'cards';
}
/** Body for members who aren't in a reminder-enabled mini league. */
export function lockSoonGenericBody(round, cycling) {
    const action = openRoundActionPhrase(round, cycling);
    if (cycling) {
        return `${round.label} locks when it starts — call ${action}.`;
    }
    if (round.pickMode === 'FLEXIBLE') {
        return `${round.label} locks at the first kickoff. Build ${action}.`;
    }
    return `${round.label} locks at the first kickoff. Get ${action} in.`;
}
/** Body for members nudged via a mini-league reminder. */
export function lockSoonFriendsBody(round, cycling) {
    const action = openRoundActionPhrase(round, cycling);
    if (cycling) {
        return `Your friends are waiting — call ${action} for ${round.label}.`;
    }
    if (round.pickMode === 'FLEXIBLE') {
        return `Your friends are waiting — build ${action} for ${round.label}.`;
    }
    return `Your friends are waiting — get ${action} in for ${round.label}.`;
}
/** Short CTA labels for in-app notification cards (sport-aware). */
export function notificationCtaLabel(type, sport) {
    const cycling = sport === 'CYCLING';
    switch (type) {
        case 'NEW_ROUND':
        case 'PICKS_LOCK_SOON':
        case 'MINI_LEAGUE_REMINDER':
            return cycling ? 'Call your duels' : 'Build your cards';
        case 'DUEL_CHALLENGE':
        case 'DUEL_RESULT':
            return 'View the duel';
        case 'ROUND_SETTLED':
        case 'PROMOTED':
        case 'RELEGATED':
            return 'See results';
        case 'EXACT_BONUS':
        case 'SCORER_BONUS':
            return 'See card breakdown';
        case 'MATCH_KICKOFF':
        case 'LIVE_GOAL':
        case 'MATCH_RESULT':
            return 'View your card';
        case 'FRIEND_PASSED':
            return 'View standings';
        case 'MINI_LEAGUE_JOIN':
        case 'MINI_LEAGUE_RESULT':
            return 'View mini league';
        default:
            return null;
    }
}
//# sourceMappingURL=notificationCopy.js.map